import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "captionText" }
const _hoisted_2 = { class: "text-button font-weight-bold message-btn" }
const _hoisted_3 = { class: "captionText" }
const _hoisted_4 = { class: "text-button font-weight-bold message-btn" }
const _hoisted_5 = { class: "captionText" }
const _hoisted_6 = { class: "text-button font-weight-bold message-btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, { class: "mt-2 mb-2" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, {
        cols: "4",
        class: "pr-2"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            class: "",
            variant: "outlined",
            width: "100%",
            onClick: _ctx.saveDraft,
            loading: _ctx.btnDraftLoading,
            disabled: _ctx.disabled
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('form.draftLine1')), 1),
                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('form.draftLine2')), 1)
              ])
            ]),
            _: 1
          }, 8, ["onClick", "loading", "disabled"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "4",
        class: "pl-1 pr-1"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            class: "",
            color: "primary",
            variant: "outlined",
            width: "100%",
            onClick: _ctx.saveSendReady,
            loading: _ctx.btnReadyLoading,
            disabled: _ctx.disabled
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('form.readyLine1')), 1),
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('form.readyLine2')), 1)
              ])
            ]),
            _: 1
          }, 8, ["onClick", "loading", "disabled"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "4",
        class: "pl-2"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            class: "",
            color: "primary",
            variant: "flat",
            width: "100%",
            onClick: _ctx.sendMessage,
            loading: _ctx.btnSendLoading,
            disabled: _ctx.disabled
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('form.sendLine1')), 1),
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('form.sendLine2')), 1)
              ])
            ]),
            _: 1
          }, 8, ["onClick", "loading", "disabled"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}